var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9395 3.00012C18.2805 3.00012 19.5705 3.53012 20.5195 4.48112C21.4695 5.43012 22.0005 6.71012 22.0005 8.05012V15.9501C22.0005 18.7401 19.7305 21.0001 16.9395 21.0001H7.06049C4.26949 21.0001 2.00049 18.7401 2.00049 15.9501V8.05012C2.00049 5.26012 4.25949 3.00012 7.06049 3.00012H16.9395ZM18.5305 9.54012L18.6105 9.46012C18.8495 9.17012 18.8495 8.75012 18.5995 8.46012C18.4605 8.31112 18.2695 8.22012 18.0705 8.20012C17.8605 8.18912 17.6605 8.26012 17.5095 8.40012L13.0005 12.0001C12.4205 12.4811 11.5895 12.4811 11.0005 12.0001L6.50049 8.40012C6.18949 8.17012 5.75949 8.20012 5.50049 8.47012C5.23049 8.74012 5.20049 9.17012 5.42949 9.47012L5.56049 9.60012L10.1105 13.1501C10.6705 13.5901 11.3495 13.8301 12.0605 13.8301C12.7695 13.8301 13.4605 13.5901 14.0195 13.1501L18.5305 9.54012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.48adc21ad49e8dc8697a84beb8185d37.svg";
export { ForwardRef as ReactComponent };